import { createClient } from '@supabase/supabase-js';
import React, { FC, useCallback, useState } from 'react'

type FormModalProps = {
    onClose: () => void;
}

const supabase = createClient("https://rgbpcypagbxucucbairq.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJnYnBjeXBhZ2J4dWN1Y2JhaXJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA5MzgzNTMsImV4cCI6MjA1NjUxNDM1M30.Rsh4BSZBqTRQZrFu2btVKCmcNcRXdBoN3zV4CjbB-OQ");

export const FormModal: React.FC<FormModalProps> = ({ onClose }) => {
  const [name, setName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const gtag_report_conversion = (url?: string) => {
    if (typeof window !== "undefined" && (window as any).gtag) {
      var callback = function () {
        if (typeof url !== "undefined") {
          window.location.href = url;
        }
      };
  
      (window as any).gtag("event", "conversion", {
        send_to: "AW-16965931005/DHeiCL2Y9rEaEP2f_pk_",
        value: 1.0,
        currency: "CHF",
        event_callback: callback,
      });
  
      console.log("✅ Google Ads Conversion Tracked!");
    }
  };

  const handleRegistration = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    const { data, error } = await supabase
      .from("pre-registration")
      .insert([{ name, lastName, email }])
      .select();

    if (error) {
      console.error("Error inserting data:", error.message);
      setMessage("❌ Failed to register. Please try again.");
    } else {
      console.log("Inserted:", data);
      setMessage("✅ Registration successful! Thank you for signing up.");
      setName("");
      setLastName("");
      setEmail("");

      gtag_report_conversion();
    }

    setLoading(false);
  }, [name, lastName, email]);

  
  return (
    <div className="fixed inset-0 flex items-center bg-primaryBlack/20 backdrop-blur-md justify-center z-50">
      <div className="absolute inset-0"></div>

      <div className="bg-primaryBlue rounded-2xl shadow-xl p-8 w-[90%] max-w-md relative z-50">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition"
        >
          X
        </button>

        {message ? (
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Pre-Registration</h2>
            <p className={`text-lg ${message.includes("Failed") ? "text-red-500" : "text-green-500"}`}>
              {message}
            </p>
            <button
              onClick={onClose}
              className="mt-6 w-full bg-lightOrange hover:bg-primaryOrange text-primaryBlue font-semibold py-3 rounded-lg transition-all duration-300"
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">Pre-Register Now</h2>

            <form className="space-y-4" onSubmit={handleRegistration}>
              <input
                type="text"
                value={name}
                placeholder="First Name"
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-linkColor outline-none"
                required
              />
              <input
                type="text"
                value={lastName}
                placeholder="Last Name"
                onChange={(e) => setLastName(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-linkColor outline-none"
                required
              />
              <input
                type="email"
                value={email}
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-linkColor outline-none"
                required
              />

              <button
                type="submit"
                className="w-full bg-lightOrange hover:bg-primaryOrange text-primaryBlue font-semibold py-3 rounded-lg transition-all duration-300"
                disabled={loading || !name || !lastName || !email}
              >
                {loading ? "Registering..." : "Pre-Register"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
